import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

/**
 * @param {import('./typedefs').AccountType} accountType
 * @param {import('./typedefs.js').Range} range
 */
function useSummary(accountType, range) {
  // Hardcode size to 50 until BE pagination issue is resolved
  const { cb, key } = fetch(accountType, range);

  // TODO: Change to useInfiniteQuery if BE pagination issue is resolved
  // https://ajaib.atlassian.net/browse/ST-4403
  // const { data, isInitialLoading, isFetchingNextPage, fetchNextPage, hasNextPage } =
  //   useInfiniteQuery(key, cb, {
  //     getNextPageParam: (last) => !!last.next,
  //     select: (_data) => _data.pages?.flatMap((page) => page?.results || []),
  //   });

  const { data, isSuccess } = useQuery(key, cb, { select: (_data) => _data.result });

  return { data, isSuccess };
}

export default { useSummary };
